var _polygon, _polygon2, _path, _path2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNosearch2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.93,446.57a7,7,0,0,1,4.35,3.32,12.46,12.46,0,0,1,1.55,5.35c.3,3.62-1,7.58-2.6,10.84-3.5-2-5.08-6.41-5.74-8.69-1.05-3.6-.76-10.75,2.44-10.82",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.84,471.23a6,6,0,0,1,.79-5.93A7.88,7.88,0,0,1,65,462.37a3.37,3.37,0,0,1,2.74.63,2.57,2.57,0,0,1,.54,2.53,5.25,5.25,0,0,1-1.51,2.22c-2.26,2.13-4.84,3.77-7.93,3.48",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.18,482.82a3.91,3.91,0,0,1,0-.74c0-.53,0-1.22,0-2a20.85,20.85,0,0,1,.78-6.67,12.91,12.91,0,0,1,3.55-5.68,8.51,8.51,0,0,1,1.68-1.17,4.15,4.15,0,0,1,.5-.24l.18-.07a15.19,15.19,0,0,0-2.23,1.62,13.22,13.22,0,0,0-3.43,5.62A22.36,22.36,0,0,0,57.3,480c0,.86,0,1.56-.06,2A4.89,4.89,0,0,1,57.18,482.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.19,452s0,.1.1.31.13.53.23.9c.2.78.47,1.92.8,3.32.65,2.82,1.5,6.72,2.34,11.05s1.51,8.26,2,11.12c.22,1.43.39,2.58.5,3.38l.12.93a1.54,1.54,0,0,1,0,.32,2.29,2.29,0,0,1-.08-.32c0-.23-.09-.54-.16-.91-.15-.83-.34-2-.59-3.37-.49-2.85-1.19-6.77-2-11.1s-1.65-8.23-2.26-11.05c-.3-1.39-.54-2.53-.72-3.35-.08-.37-.14-.68-.19-.91A1.11,1.11,0,0,1,51.19,452Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.12,474.4a13.94,13.94,0,0,0-9.45-8.53c-1.09-.28-2.45-.34-3.12.57s-.23,2.19.38,3.14a11.9,11.9,0,0,0,12.18,5.12",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.82,469.12a5.49,5.49,0,0,1,.68.15c.22.06.49.13.79.24s.66.22,1,.39.78.34,1.2.58a13.14,13.14,0,0,1,1.3.78,14,14,0,0,1,5.29,6.53,12.46,12.46,0,0,1,.43,1.25,9.65,9.65,0,0,1,.26,1.07,6.29,6.29,0,0,1,.14.81,4,4,0,0,1,.06.7c-.06,0-.15-1-.64-2.52a12,12,0,0,0-.46-1.23,14.76,14.76,0,0,0-.64-1.35,16.27,16.27,0,0,0-2-2.8,17,17,0,0,0-2.58-2.26c-.44-.29-.86-.57-1.28-.79a13,13,0,0,0-1.16-.6C46.78,469.41,45.8,469.18,45.82,469.12Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149,450.4l.48,21.09S128.24,479.06,128,483l40.92.52.59-32.88Z",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M162.19,469.88a1.67,1.67,0,0,1,1.13,1.92,1.6,1.6,0,0,1-1.9,1.13,1.76,1.76,0,0,1-1.18-2,1.66,1.66,0,0,1,2.1-1",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.87,483.49l-.07-3.31-39.2.73s-1.84.77-1.65,2.06Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M148.85,471.27c0,.2,1,.3,2,1s1.49,1.5,1.67,1.42-.1-1.23-1.29-2S148.81,471.09,148.85,471.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.54,473c0,.19.81.54,1.48,1.4s.85,1.75,1,1.74.34-1.13-.51-2.18S144.54,472.8,144.54,473Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142,478.1c.19,0,.48-1,0-2.06s-1.43-1.54-1.52-1.38.49.76.88,1.67S141.84,478.07,142,478.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.27,466.45c.09.18,1-.08,2.13,0s2,.46,2.12.29-.74-.89-2.07-1S149.18,466.29,149.27,466.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "149.13 454.58 149.21 458.33 169.32 458.41 169.41 454.07 149.13 454.58"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M149.25,462.2a3.94,3.94,0,0,0,2.05,0,9.27,9.27,0,0,0,3.34-1.24,2.7,2.7,0,0,0,.63-.47.89.89,0,0,0,.1-1.07,1.09,1.09,0,0,0-.87-.46,2.59,2.59,0,0,0-.77.09,8.34,8.34,0,0,0-1.28.42,7.42,7.42,0,0,0-1.9,1.22c-1,.87-1.3,1.61-1.23,1.65s.56-.55,1.54-1.27a7.87,7.87,0,0,1,1.84-1,7.78,7.78,0,0,1,1.18-.35c.43-.11.8-.11.91.09s0,.1,0,.23a2.1,2.1,0,0,1-.46.34,10.63,10.63,0,0,1-3.08,1.34A13.11,13.11,0,0,0,149.25,462.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.51,462.49a3.27,3.27,0,0,0,.57-2,6.83,6.83,0,0,0-.25-2.24,6.66,6.66,0,0,0-.51-1.26A1.7,1.7,0,0,0,148,456a1,1,0,0,0-.87.56,2.82,2.82,0,0,0-.22.75,4.58,4.58,0,0,0,0,1.38,4.77,4.77,0,0,0,.85,2.13c.79,1.07,1.62,1.32,1.64,1.25s-.63-.49-1.23-1.52a4.59,4.59,0,0,1-.57-3.12c.07-.43.24-.78.4-.73s.55.33.71.68a6.05,6.05,0,0,1,.49,1.12,7.6,7.6,0,0,1,.38,2.05C149.63,461.71,149.4,462.45,149.51,462.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.79,450.56l-.8,21.07s21.16,7.89,21.39,11.8l-40.92-.07-.11-32.9Z",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M207.34,469.84a1.67,1.67,0,0,0-1.16,1.9,1.62,1.62,0,0,0,1.88,1.17,1.77,1.77,0,0,0,1.22-2,1.67,1.67,0,0,0-2.09-1",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M200.46,483.36l.12-3.32,39.19,1.31s1.82.79,1.61,2.08Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M220.66,471.43c0,.2-1,.28-2,.93s-1.51,1.48-1.7,1.4.12-1.24,1.32-2S220.7,471.24,220.66,471.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225,473.21c0,.19-.82.53-1.5,1.37s-.88,1.74-1.08,1.73-.33-1.14.54-2.17S224.94,473,225,473.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.38,478.35c-.19,0-.46-1,.05-2.05s1.45-1.53,1.54-1.36-.5.75-.91,1.65S227.57,478.33,227.38,478.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.31,466.6c-.09.18-1-.09-2.13,0s-2,.43-2.12.26.74-.88,2.08-.95S220.4,466.45,220.31,466.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "220.63 454.73 220.49 458.49 200.38 458.27 200.35 453.93 220.63 454.73"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M220.39,462.35a3.91,3.91,0,0,1-2,0,9.08,9.08,0,0,1-2.15-.66A9,9,0,0,1,215,461a2.48,2.48,0,0,1-.62-.48.86.86,0,0,1-.09-1.06,1.1,1.1,0,0,1,.88-.46,2.55,2.55,0,0,1,.77.11,7,7,0,0,1,1.27.44,7.64,7.64,0,0,1,1.89,1.24c.94.88,1.27,1.63,1.2,1.67s-.55-.56-1.52-1.29a7.92,7.92,0,0,0-1.82-1,8.14,8.14,0,0,0-1.18-.37c-.43-.11-.8-.12-.91.08s0,.1,0,.23a2.1,2.1,0,0,0,.46.35,9.94,9.94,0,0,0,1.08.62,10.42,10.42,0,0,0,2,.76A13.61,13.61,0,0,1,220.39,462.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.13,462.63a3.23,3.23,0,0,1-.54-2,6.47,6.47,0,0,1,.81-3.48,1.69,1.69,0,0,1,1.31-1,1,1,0,0,1,.85.58,2.58,2.58,0,0,1,.21.75,4.91,4.91,0,0,1,0,1.38,4.7,4.7,0,0,1-.88,2.11c-.8,1.06-1.64,1.3-1.65,1.23s.63-.48,1.24-1.5a4.73,4.73,0,0,0,.65-1.93,4.27,4.27,0,0,0,0-1.18c-.07-.43-.23-.79-.39-.74s-.55.32-.72.67a6.85,6.85,0,0,0-.51,1.11,7.32,7.32,0,0,0-.4,2C220,461.85,220.23,462.6,220.13,462.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "199.3 247.78 225.52 469.92 200.49 471.09 169.82 288.65 171.12 470.12 145.88 468.56 133.4 257.89 199.3 247.78",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.84,125.84a71.67,71.67,0,0,1-3.28-12,25.23,25.23,0,0,1,.83-12.3c.22-.59,2-4.57,2.66-4.52.45,0-.66,3.75-.42,4.13a21.41,21.41,0,0,1,2.55,12.42,55.79,55.79,0,0,1-2.34,12.26",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.47,160.42a11.82,11.82,0,0,1-11.73-11.68l-.5-38.73c-.47-10.4,5.2-19.34,15.61-19.52l1,0a18.61,18.61,0,0,1,17.83,17.87c.35,9,.63,19,.37,23.8-.54,10-10.58,11.11-10.58,11.11s0,2.32,0,5.25a11.84,11.84,0,0,1-11.94,11.86Z",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.43,143.31a24.16,24.16,0,0,1-12.84-4.37s2.87,7.38,12.87,6.9Z",
    style: {
      fill: "#995037"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.87,116.48a1.43,1.43,0,0,1-1.43,1.38,1.37,1.37,0,0,1-1.42-1.34,1.43,1.43,0,0,1,1.43-1.39A1.37,1.37,0,0,1,179.87,116.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.74,114.5c-.19.18-1.23-.67-2.77-.73s-2.69.67-2.85.47.12-.41.62-.75a3.85,3.85,0,0,1,2.29-.6,3.74,3.74,0,0,1,2.2.81C180.68,114.08,180.83,114.42,180.74,114.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.23,115.71c-.18.18-1.23-.66-2.77-.72s-2.69.66-2.84.46.11-.41.62-.75a4,4,0,0,1,2.29-.6,3.74,3.74,0,0,1,2.19.81C166.17,115.29,166.32,115.63,166.23,115.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.3,124.46a10.72,10.72,0,0,1,2.51-.34c.39,0,.77-.09.85-.35a2.08,2.08,0,0,0-.22-1.18c-.33-1-.67-2-1-3-1.44-4.31-2.46-7.85-2.28-7.91s1.48,3.4,2.91,7.71l1,3a2.22,2.22,0,0,1,.14,1.54,1,1,0,0,1-.66.55,2.81,2.81,0,0,1-.67.06A9.87,9.87,0,0,1,170.3,124.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.92,129.86c-.22.11-.89-1.42-2.66-1.93s-3.34.35-3.44.15.23-.46.91-.78a4.22,4.22,0,0,1,2.83-.21,3.58,3.58,0,0,1,2.14,1.67C172,129.37,172,129.82,171.92,129.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.61,113.18c-.22.39-1.7-.08-3.51-.18s-3.33.13-3.5-.28c-.07-.2.24-.54.89-.83a6.12,6.12,0,0,1,5.34.35C166.44,112.62,166.71,113,166.61,113.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.2,109.55c-.3.35-1.54,0-3,0s-2.73.29-3-.07c-.13-.17.06-.52.6-.87a5,5,0,0,1,4.88,0C180.16,109,180.34,109.37,180.2,109.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.75,117.43c-.17-.08-6.78-2.31-6.84,4.53s6.81,5.48,6.82,5.29S148.75,117.43,148.75,117.43Z",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.67,124.64s-.12.08-.32.17a1.17,1.17,0,0,1-.89,0,2.93,2.93,0,0,1-1.34-2.65,3.83,3.83,0,0,1,.35-1.7,1.37,1.37,0,0,1,.9-.91.61.61,0,0,1,.7.33c.09.19.05.33.08.34s.15-.11.1-.39a.76.76,0,0,0-.27-.43.84.84,0,0,0-.65-.18,1.68,1.68,0,0,0-1.26,1,4.18,4.18,0,0,0-.43,1.9,3.09,3.09,0,0,0,1.71,3,1.27,1.27,0,0,0,1.09-.17C146.65,124.8,146.69,124.65,146.67,124.64Z",
    style: {
      fill: "#995037"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.23,97.07c1.1-.61-2.21-4.19-4.93-5.42-4.11-1.87-10.38-3-14.17-2-4.56,1.29-8.35,3.56-10.64,7.71a26.88,26.88,0,0,0-3,13.72,8.17,8.17,0,0,0,1,4.17c.95,1.51,2.78,2.47,2.7,4.55a2.89,2.89,0,0,0,.71,2.09c1.25,1.33,2.78.08,3.48-1.17,1.51-2.68,1.68-5.87,1.81-8.94a19.93,19.93,0,0,0-.43-6.5c-.33-1.14-.87-2.21-1.14-3.37a4.1,4.1,0,0,1,.49-3.41,3.52,3.52,0,0,1,.55-.56,7.12,7.12,0,0,1,7.07-1.34c3.85,1.36,10.42,3.4,12.14,2.09a10.56,10.56,0,0,0,3.06-3.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.52,271.36l-4.21-37.77-3.16-58.13-1.92-26.32-5.06.77-3.62-.95-7.35,1.45-3.84-5.9-1.9-.36c0,4.81-.72,9.24-3.18,12.44l-19.84-14.86-2.1.54-3.4,7.58s-20.76,11.78-21.88,13.46L133,197l.91,37.24-1.67,37.16Z",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136,174.11c-.08,0-.41-.89-1.21-2.23a17.15,17.15,0,0,0-3.95-4.53,16.9,16.9,0,0,0-5.31-2.83c-1.48-.48-2.45-.59-2.43-.69a2,2,0,0,1,.69,0,11.61,11.61,0,0,1,1.85.33,15.16,15.16,0,0,1,5.52,2.79,14.93,14.93,0,0,1,3.95,4.75,10,10,0,0,1,.74,1.73C136,173.86,136.07,174.09,136,174.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190,156.46a7.23,7.23,0,0,1-.57-2.66,7.43,7.43,0,0,1-.06-2.71,13.81,13.81,0,0,1,.63,5.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.5,252.84a2.36,2.36,0,0,1-.5,0l-1.41-.16c-1.22-.14-3-.42-5.15-.82a107.56,107.56,0,0,1-32.29-11.69c-1.93-1.07-3.46-2-4.49-2.67-.47-.31-.87-.56-1.19-.78s-.4-.28-.39-.3a2.15,2.15,0,0,1,.45.22l1.23.69c1.07.62,2.62,1.49,4.56,2.52a120.89,120.89,0,0,0,32.19,11.65c2.15.44,3.9.77,5.11,1l1.4.25A1.79,1.79,0,0,1,185.5,252.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.94,142.45,212.21,114l-6-9.71a22.25,22.25,0,0,0-2.8-4c-2.67-2.9-4.56-.81-4.56-.81a1.8,1.8,0,0,0-1.78-1.1,3,3,0,0,0-2.45,1.25,4.14,4.14,0,0,0-2.74-.93,2.09,2.09,0,0,0-1.27.41c-.66-.58-1.87-1.41-3-1-.91.33-6.42,4.52-7.78,6.63-.67,1,.57,2.4,2.25,1.77a14.63,14.63,0,0,0,2-.82,5.37,5.37,0,0,0,1.36-1.1s-1.39,2.44,0,2.86a3.17,3.17,0,0,0,2.61-.63c.53-.45,1.14-1,1.72-1.59a.36.36,0,0,0-.07.1c-.77,1.13,1.23,2.81,2.2,2.13a13.4,13.4,0,0,0,1.3-1c2.25,1.63-.88,3.72-2.2,3.61a41.48,41.48,0,0,0-6.1,0,4.37,4.37,0,0,0-2.79,1c-.74.76,0,2.38,1.09,2.54,2,.3,4.42.73,7,1.39,3,.78,11,3.36,11,3.36l.77.63,10.78,26.29-18.45,3.91-4.12,23.38,33.31-9C230.93,159.58,234.49,149.59,229.94,142.45Z",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.13,118.31a1.89,1.89,0,0,1-.42-.1l-1.2-.34-4.38-1.3-3-.92c-1.09-.33-2.25-.68-3.49-1a32,32,0,0,0-3.9-.81,6.78,6.78,0,0,1-2.12-.38,1.48,1.48,0,0,1-.47-.36.64.64,0,0,1-.16-.28l-.05-.29a2.65,2.65,0,0,1,.08-1.15,1.56,1.56,0,0,1,.76-.89,5.52,5.52,0,0,1,1-.41,7.17,7.17,0,0,1,2.14-.26c1.41,0,2.73.21,4,.16a13.35,13.35,0,0,0,1.83-.18c.59-.11,1.16-.26,1.71-.4a9.07,9.07,0,0,1,3.15-.4,8.5,8.5,0,0,1,2.54.64,17.3,17.3,0,0,1,1.77.87c.48.27.83.49,1.07.64a2.13,2.13,0,0,1,.36.24,2.56,2.56,0,0,1-.38-.19l-1.1-.59a16.3,16.3,0,0,0-1.78-.82,8.42,8.42,0,0,0-2.5-.59,8.76,8.76,0,0,0-3.07.42c-.55.15-1.12.31-1.72.42a11.39,11.39,0,0,1-1.87.2c-1.29.06-2.64-.13-4-.15a6.79,6.79,0,0,0-2.05.26c-.66.21-1.42.45-1.62,1.12a2.5,2.5,0,0,0-.06,1l0,.25a.46.46,0,0,0,.1.18,1.14,1.14,0,0,0,.39.29,7,7,0,0,0,2,.36,32,32,0,0,1,3.93.83c1.24.32,2.4.67,3.48,1l3,.95,4.36,1.39,1.18.39A2.77,2.77,0,0,1,201.13,118.31Z",
    style: {
      fill: "#995037"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.47,98.13c0,.05-.84.55-2.12,1.52a23.27,23.27,0,0,0-2.12,1.83c-.75.74-1.55,1.6-2.49,2.41a2.64,2.64,0,0,0-1,1.33.95.95,0,0,0,.66,1.16,2.74,2.74,0,0,0,1.42,0,6.5,6.5,0,0,0,1.24-.36,8.9,8.9,0,0,0,2.2-1.33,2.51,2.51,0,0,1-.49.51,6.63,6.63,0,0,1-1.63,1,6.78,6.78,0,0,1-1.27.4,3.06,3.06,0,0,1-1.56,0,1.28,1.28,0,0,1-.7-.54,1.3,1.3,0,0,1-.14-.92,2.82,2.82,0,0,1,1.09-1.49c.92-.8,1.72-1.65,2.49-2.38a18.4,18.4,0,0,1,2.19-1.81c.65-.47,1.21-.81,1.6-1A3.94,3.94,0,0,1,187.47,98.13Z",
    style: {
      fill: "#995037"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.23,100.37a6.23,6.23,0,0,1-.63.75l-1.78,1.95L189.16,106a6.45,6.45,0,0,1-1.88,1.43,2.84,2.84,0,0,1-1.24.31,1.7,1.7,0,0,1-1.24-.5,1.14,1.14,0,0,1-.3-.67,2,2,0,0,1,.08-.7,3.91,3.91,0,0,1,.57-1.18h0l2.64-2.84c.81-.87,1.59-1.57,2.22-2.17a4.64,4.64,0,0,1,.93-.74,2.29,2.29,0,0,1,.88-.19c.47,0,.75,0,.73.06a2.23,2.23,0,0,0-.73,0A2.46,2.46,0,0,0,191,99a4.72,4.72,0,0,0-.87.75c-.62.62-1.38,1.33-2.17,2.2s-1.67,1.84-2.62,2.87v0a4,4,0,0,0-.52,1.1,1.71,1.71,0,0,0-.07.59.89.89,0,0,0,.23.51,1.41,1.41,0,0,0,1,.41,2.48,2.48,0,0,0,1.12-.28,6.44,6.44,0,0,0,1.8-1.35l2.71-2.84,1.84-1.9.51-.5A.9.9,0,0,1,194.23,100.37Z",
    style: {
      fill: "#995037"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.51,103s0,.17-.21.32a1.17,1.17,0,0,1-.9.22,1.19,1.19,0,0,1-.77-.51c-.12-.21-.12-.36-.09-.37s.11.1.25.24a1.2,1.2,0,0,0,.66.36,1.31,1.31,0,0,0,.74-.11C202.38,103,202.48,103,202.51,103Z",
    style: {
      fill: "#995037"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.16,105.46c-.06.05-.46-.36-.82-1a2.33,2.33,0,0,1-.45-1.19c.07,0,.34.46.69,1A3.9,3.9,0,0,1,203.16,105.46Z",
    style: {
      fill: "#995037"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.36,115.13a3.44,3.44,0,0,1-.52-1.12,9.48,9.48,0,0,1-.44-3,9.29,9.29,0,0,1,.52-2.94,4.21,4.21,0,0,1,.54-1.12,15.37,15.37,0,0,0-.78,4.06A14.57,14.57,0,0,0,204.36,115.13Z",
    style: {
      fill: "#995037"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.92,152.61c-.06,0-.11-.58-.39-1.46a9.32,9.32,0,0,0-.64-1.48,8.88,8.88,0,0,0-2.59-2.95,8.3,8.3,0,0,0-1.39-.83c-.84-.39-1.41-.52-1.39-.57s.14,0,.4.05a6,6,0,0,1,1.07.34,7.62,7.62,0,0,1,1.46.79,8.41,8.41,0,0,1,2.67,3.05,8.12,8.12,0,0,1,.6,1.55,6.2,6.2,0,0,1,.2,1.1A1.49,1.49,0,0,1,218.92,152.61Z",
    style: {
      fill: "#995037"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.85,101.31a2.38,2.38,0,0,1-.28.42c-.2.26-.49.62-.86,1.06-.74.89-1.8,2.08-3,3.33a5.49,5.49,0,0,1-2,1.53,1.71,1.71,0,0,1-1.14,0,1.42,1.42,0,0,1-.73-.67,2.23,2.23,0,0,1-.21-1.38,1.27,1.27,0,0,1,.13-.49,2.38,2.38,0,0,1,0,.5,2.35,2.35,0,0,0,.27,1.27,1.24,1.24,0,0,0,.64.55,1.5,1.5,0,0,0,1,0,5.64,5.64,0,0,0,1.87-1.49c1.24-1.24,2.32-2.41,3.09-3.26A12.57,12.57,0,0,1,197.85,101.31Z",
    style: {
      fill: "#995037"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.7,101.73a2.4,2.4,0,0,1-.3.39c-.21.24-.51.58-.89,1l-1.35,1.46-.8.85a7.22,7.22,0,0,1-.94.87,2.33,2.33,0,0,1-1.21.48,1.26,1.26,0,0,1-1.14-.5.93.93,0,0,1-.18-.58,1,1,0,0,1,.17-.53,8.93,8.93,0,0,1,.54-.76c.33-.46.6-.82.8-1.07a1.81,1.81,0,0,1,.32-.37s-.07.16-.24.43-.42.65-.73,1.11c-.15.24-.35.49-.5.76a.75.75,0,0,0,0,.87,1,1,0,0,0,.92.38,2,2,0,0,0,1.08-.44,6.55,6.55,0,0,0,.91-.83l.81-.84,1.38-1.41.95-.94C201.55,101.83,201.68,101.72,201.7,101.73Z",
    style: {
      fill: "#995037"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "192.54 149.4 208.03 146.01 206.12 172.52 190.61 178.97 187.36 174.6 186.87 160.92 192.54 149.4",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.37,163a7.17,7.17,0,0,0-3.16,4.34c-.94,3.2-8.66,30-8.66,30l13-.33,10.33-12.55L126,163.28Z",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "191.01 229.63 361.68 259.41 351.42 135.4 191.01 206.78 191.01 229.63",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "191.01 229.63 361.68 259.41 351.42 135.4 191.01 206.78 191.01 229.63",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M310.87,193.15a2.4,2.4,0,1,1-3.38-.36A2.4,2.4,0,0,1,310.87,193.15Z",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M310.87,193.15a2.4,2.4,0,1,1-3.38-.36A2.4,2.4,0,0,1,310.87,193.15Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M252.91,200.85a1.2,1.2,0,1,1-1.69-.18A1.21,1.21,0,0,1,252.91,200.85Z",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M252.91,200.85a1.2,1.2,0,1,1-1.69-.18A1.21,1.21,0,0,1,252.91,200.85Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M281.86,215a1.2,1.2,0,1,1-1.68-.18A1.2,1.2,0,0,1,281.86,215Z",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M281.86,215a1.2,1.2,0,1,1-1.68-.18A1.2,1.2,0,0,1,281.86,215Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 302.54,
    cy: 178.07,
    r: 1.2,
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 302.54,
    cy: 178.07,
    r: 1.2,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M199.36,210.42a1.19,1.19,0,1,1-1.68-.18A1.18,1.18,0,0,1,199.36,210.42Z",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M199.36,210.42a1.19,1.19,0,1,1-1.68-.18A1.18,1.18,0,0,1,199.36,210.42Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 357.85,
    cy: 197.28,
    rx: 19.11,
    ry: 62.32,
    transform: "translate(-14.1 28.08) rotate(-4.41)",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 357.85,
    cy: 197.28,
    rx: 19.11,
    ry: 62.32,
    transform: "translate(-14.1 28.08) rotate(-4.41)",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M189.62,170.9a6.43,6.43,0,0,0-3.31-2.23c-6.12-2.18-13.09-.44-18.57,3s-9.78,8.51-14,13.46c-6.92,8.16-13.57,14.67-20.49,22.83l.15,6.18c5,.09,9.9-2.69,13.61-6s6.5-7.47,9.18-11.65,5.29-8.44,8.73-12a8,8,0,0,1,4.54-2.79c1.85-.23,3.63.68,5.43,1.19a13.07,13.07,0,0,0,14.09-5.3C190.29,175.63,191,172.88,189.62,170.9Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M180.21,205.74c-2.33-.28-4.55,1.37-5.67,3.43a17.9,17.9,0,0,0-1.62,6.8q-.9,8.68-1.78,17.37a14.52,14.52,0,0,0,.3,6.4,14.22,14.22,0,0,0,2.34,3.8,13.46,13.46,0,0,0,3.23,3.33,11.57,11.57,0,0,0,5.62,1.44,39.37,39.37,0,0,0,8.26-.42,7,7,0,0,0,4-1.61,7.09,7.09,0,0,0,1.6-3.7c2-9.93.55-20.2-.91-30.24-.31-2.13-.66-4.37-2-6.06-1.72-2.18-4.76-3-7.52-2.66a25,25,0,0,0-7.83,2.71"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M111.9,194.18l-2.2,5.88c-.65,2.47-1.63,7.82-.75,10.22.7,1.91,1.92,3.74,4,4,4.67.66,16.39-9.2,16.39-9.2l-2.74-12.33Z",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.17,161.53s-40.22,26.19-42,27.5a22.38,22.38,0,0,0-7.26,7.11c-3.27,4.72-5.18,15.84.07,18.17a23.81,23.81,0,0,0,7.27.62c5.65-1,17.75-7.53,23.4-14.38s25.48-27.82,25.48-27.82Z",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.59,161.91s5.64-2.4,7.53-2.51c1.53-.08,12.53,1.69,16.37,1.75a2.24,2.24,0,0,1,2,1.3c1,2.17,2.92,6.37,3.26,7.14.48,1.06-.33,3.24-1.32,4.58a1.66,1.66,0,0,1-2.43,1.21l-.43,1.06a3.12,3.12,0,0,1-3.17,1.91l-5.67-.55a2,2,0,0,1,2-2.32l3.2-.33-.05-1.75s-5.63.75-7.32.73-10.5-1.65-10.5-1.65Z",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.17,175.43c-.15,0-.35-2.15-1.08-4.71s-1.68-4.5-1.54-4.57a15.68,15.68,0,0,1,2.62,9.28Z",
    style: {
      fill: "#995037"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.65,173.43c-.16,0-.35-2.16-1.08-4.71s-1.68-4.5-1.54-4.58a15.74,15.74,0,0,1,2.62,9.29Z",
    style: {
      fill: "#995037"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.82,186.59c.12.16-4.09,2.31-7.87,6.56s-5.33,8.73-5.51,8.63a2.56,2.56,0,0,1,.21-.79,21.56,21.56,0,0,1,.85-2.06,25.81,25.81,0,0,1,4.06-6.12,27.43,27.43,0,0,1,5.58-4.78c.8-.5,1.45-.89,1.93-1.12S123.8,186.55,123.82,186.59Z",
    style: {
      fill: "#995037"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.13,173a3.71,3.71,0,0,1-.63.17c-.42.09-1,.21-1.84.31a24.58,24.58,0,0,1-6.87-.05c-.72-.1-1.47-.23-2.25-.37a11.29,11.29,0,0,0-2.37-.29,3.2,3.2,0,0,0-2,1.28c-.58.67-1.17,1.43-1.82,2.12l-8.39,9.19c-6,6.49-11.65,12.15-15.78,16.21-2.06,2-3.76,3.64-4.94,4.74l-1.37,1.26a3.55,3.55,0,0,1-.5.42s.13-.18.43-.49.77-.79,1.3-1.33l4.82-4.87c4.06-4.11,9.66-9.81,15.66-16.29l8.41-9.16c.67-.69,1.22-1.4,1.83-2.11a3.66,3.66,0,0,1,2.34-1.4,4.65,4.65,0,0,1,1.31.1l1.18.23,2.23.4a26.51,26.51,0,0,0,6.79.21c.81-.07,1.43-.16,1.85-.21A3.1,3.1,0,0,1,183.13,173Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.42,175.34c.05,0,0,.54-.56,1.15a4.51,4.51,0,0,1-2.76,1.4,8.3,8.3,0,0,1-3-.24c-.75-.19-1.19-.36-1.18-.43a3.56,3.56,0,0,1,1.25.07,11.28,11.28,0,0,0,2.91.08,4.87,4.87,0,0,0,2.57-1.13C186.15,175.75,186.34,175.31,186.42,175.34Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189,173.43c.14,0,.13.4,0,.78s-.37.65-.5.6-.13-.4,0-.78S188.82,173.38,189,173.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.83,255.71a7.31,7.31,0,0,1-1.47,0c-.94,0-2.3,0-4-.15a94.18,94.18,0,0,1-25.7-5.4c-1.58-.58-2.85-1.08-3.71-1.46a7.2,7.2,0,0,1-1.32-.63,9.14,9.14,0,0,1,1.4.44c.88.33,2.16.77,3.75,1.3a116.48,116.48,0,0,0,12.65,3.44,119.45,119.45,0,0,0,13,1.94c1.67.15,3,.26,4,.32A7.66,7.66,0,0,1,192.83,255.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.43,135.09a2.2,2.2,0,0,1-.13.85,6.28,6.28,0,0,1-1,2.13,10,10,0,0,1-6.67,3.8,18,18,0,0,1-7.69-.88c-.94-.29-1.69-.57-2.2-.78a3,3,0,0,1-.78-.38,30.92,30.92,0,0,1,3.09.81,19.82,19.82,0,0,0,7.51.72,10.18,10.18,0,0,0,6.45-3.51A10.68,10.68,0,0,0,181.43,135.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.07,171.76a19.15,19.15,0,0,1-3.89,2,17.74,17.74,0,0,1-4.09,1.48,19.15,19.15,0,0,1,3.89-1.95A17.74,17.74,0,0,1,205.07,171.76Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.61,160.22a15.28,15.28,0,0,1-2.61,1.25c-1.64.7-3.94,1.6-6.51,2.51s-4.92,1.62-6.64,2.1a14.3,14.3,0,0,1-2.82.65,17.85,17.85,0,0,1,2.71-1l6.58-2.25,6.55-2.35A15.91,15.91,0,0,1,226.61,160.22Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.1,208.78S172,217.92,176.22,227a10.12,10.12,0,0,0,5,4.93l.14.06h8.87a10.23,10.23,0,0,0,5.24-6.86c.94-4.4,1.31-11-2.8-16.15l-.38-1.29Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.1,208.78l.94-.09,2.8-.27c2.44-.24,6-.61,10.47-1h.17l0,.16.39,1.29,0-.07a16.69,16.69,0,0,1,3.48,9.89,25.36,25.36,0,0,1-.5,6,10.38,10.38,0,0,1-2.89,5.62,10.93,10.93,0,0,1-1.22,1c-.22.16-.44.31-.67.45l-.34.21-.17.09-.09.05,0,0h0l-.12,0h-8.93l-.05,0a10.58,10.58,0,0,1-4.35-3.51,9.69,9.69,0,0,1-1.22-2.34c-.14-.4-.33-.79-.44-1.19s-.21-.8-.31-1.19a18.28,18.28,0,0,1,.17-8.34,24.2,24.2,0,0,1,1.94-5.13c.3-.56.55-1,.72-1.27a2.36,2.36,0,0,1,.3-.41,3.1,3.1,0,0,1-.22.45c-.16.3-.38.73-.65,1.31a25.39,25.39,0,0,0-1.79,5.12,18.18,18.18,0,0,0-.06,8.18c.1.38.21.76.32,1.15s.29.76.43,1.15a9,9,0,0,0,1.19,2.24,10.12,10.12,0,0,0,4.18,3.33l-.1,0h8.87l-.12,0h0l0,0,.08,0,.16-.09.33-.2c.21-.13.42-.28.63-.43a10,10,0,0,0,3.92-6.35,25.49,25.49,0,0,0,.5-5.84,16.3,16.3,0,0,0-3.31-9.65l0,0v0c-.13-.45-.26-.9-.37-1.3l.21.15c-4.3.32-7.82.53-10.31.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.74,219.44c-.07-2.5-.63-5.16-2.43-6.91a9.27,9.27,0,0,0-4.67-2.18,8.62,8.62,0,0,0-5.08.22c-2.28,1-3.66,3.35-4.33,5.74a12.16,12.16,0,0,0,.48,8.51,8,8,0,0,0,6.84,4.64l2-.16a6.24,6.24,0,0,0,5.73-3.18A12.2,12.2,0,0,0,193.74,219.44Z",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M193.74,219.44c-.07-2.5-.63-5.16-2.43-6.91a9.27,9.27,0,0,0-4.67-2.18,8.62,8.62,0,0,0-5.08.22c-2.28,1-3.66,3.35-4.33,5.74a12.16,12.16,0,0,0,.48,8.51,8,8,0,0,0,6.84,4.64l2-.16a6.24,6.24,0,0,0,5.73-3.18A12.2,12.2,0,0,0,193.74,219.44Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M193.74,219.44c-.07-2.5-.63-5.16-2.43-6.91a9.27,9.27,0,0,0-4.67-2.18,8.62,8.62,0,0,0-5.08.22c-2.28,1-3.66,3.35-4.33,5.74a12.16,12.16,0,0,0,.48,8.51,8,8,0,0,0,6.84,4.64l2-.16a6.24,6.24,0,0,0,5.73-3.18A12.2,12.2,0,0,0,193.74,219.44Z",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M193.74,219.44c-.07-2.5-.63-5.16-2.43-6.91a9.27,9.27,0,0,0-4.67-2.18,8.62,8.62,0,0,0-5.08.22c-2.28,1-3.66,3.35-4.33,5.74a12.16,12.16,0,0,0,.48,8.51,8,8,0,0,0,6.84,4.64l2-.16a6.24,6.24,0,0,0,5.73-3.18A12.2,12.2,0,0,0,193.74,219.44Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M184.57,228.69h0Z",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.17,221.07a8.71,8.71,0,0,0-2.64-5.63,3.1,3.1,0,0,0-1.17-.8,1.36,1.36,0,0,0-1.35.2,1.71,1.71,0,0,0-.34,1.68,10.59,10.59,0,0,1,.45,1.74,4.26,4.26,0,0,1-1.72,3.13,6.41,6.41,0,0,0-2.2,2.9,3.31,3.31,0,0,0,.85,2.93,4.33,4.33,0,0,0,2.5,1.47,5.8,5.8,0,0,0,3.53-1.8A7.7,7.7,0,0,0,190.17,221.07Z",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M184.57,228.69h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.17,221.07a8.71,8.71,0,0,0-2.64-5.63,3.1,3.1,0,0,0-1.17-.8,1.36,1.36,0,0,0-1.35.2,1.71,1.71,0,0,0-.34,1.68,10.59,10.59,0,0,1,.45,1.74,4.26,4.26,0,0,1-1.72,3.13,6.41,6.41,0,0,0-2.2,2.9,3.31,3.31,0,0,0,.85,2.93,4.33,4.33,0,0,0,2.5,1.47,5.8,5.8,0,0,0,3.53-1.8A7.7,7.7,0,0,0,190.17,221.07Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M185,228.47a3.16,3.16,0,0,1-1.77-2.44,2.4,2.4,0,0,1,.28-1.49,7.5,7.5,0,0,1,1.54-1.43,3.81,3.81,0,0,0,1.16-2.27,1.34,1.34,0,0,1,.1-.44.35.35,0,0,1,.35-.23c.16,0,.27.17.35.31a6.57,6.57,0,0,1,.8,2,4.2,4.2,0,0,1-.12,2.17c-.51,1.45-1.89,2.41-2.64,3.75",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.31,212.54c0,.07-.66.47-1.56,1.37a9.42,9.42,0,0,0-2.47,4.2,9.56,9.56,0,0,0,0,4.87c.33,1.23.74,1.92.66,2a4.58,4.58,0,0,1-1-1.86,8.89,8.89,0,0,1-.18-5.12,8.78,8.78,0,0,1,2.73-4.33A4.37,4.37,0,0,1,182.31,212.54Z",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.19,211.48c.05.14-.11.32-.36.42s-.5.07-.55-.07.11-.32.36-.42S184.13,211.35,184.19,211.48Z",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.31,240.24c-2.5,0-5.15-.05-7.49-.19a7.63,7.63,0,0,1-5.69-2.48,6.85,6.85,0,0,1-1.46-4.81c0-.66,1.41-19.74,2-27.78.21-3,1.19-5.18,2.92-6.47a7,7,0,0,1,5.22-1.1l9.26-.12c6.17-.22,8.16,3.53,8.34,5.56.16,1.28,3.21,25.73,2.65,30.52-.63,5.33-5.94,6.61-6.16,6.66l-.17,0C194.62,240.05,190.26,240.24,185.31,240.24Zm-5.83-41.09a4.73,4.73,0,0,0-2.85.87c-1.26.94-2,2.65-2.16,5.08-.55,8.15-1.94,27.61-1.95,27.8v0a5.1,5.1,0,0,0,1.06,3.45,5.92,5.92,0,0,0,4.36,1.8c6.5.39,15.56,0,16.58,0,.58-.15,4.21-1.27,4.66-5,.54-4.58-2.62-29.84-2.66-30.09v0a4.12,4.12,0,0,0-.94-2c-1.11-1.32-3-1.94-5.5-1.85l-9.5.11-.11,0A4.44,4.44,0,0,0,179.48,199.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.31,191.71h19.21L188.21,188a5.62,5.62,0,0,0-2.51-.6h0a5.54,5.54,0,0,0-2.64.67Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.5,
    y: 190.94,
    width: 12.83,
    height: 15.99,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177.4,
    y: 206.34,
    width: 16.6,
    height: 2.58,
    rx: 1.17,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.18,201.91a5.59,5.59,0,0,1,0-1.28c0-.92.05-2.08.08-3.46.09-2.92.26-6.95.47-11.41.06-1.12.08-2.19.19-3.26a10.6,10.6,0,0,1,.78-3,10.41,10.41,0,0,1,3.16-4.11,9.89,9.89,0,0,1,3.08-1.65,6.71,6.71,0,0,1,.92-.23c.21,0,.33-.06.33,0a9.64,9.64,0,0,1-1.18.46,10.91,10.91,0,0,0-2.92,1.74,10.38,10.38,0,0,0-3,4,10.53,10.53,0,0,0-.72,2.86c-.09,1-.11,2.13-.17,3.24-.21,4.45-.43,8.48-.62,11.4-.1,1.38-.18,2.53-.25,3.45A5.81,5.81,0,0,1,174.18,201.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.49,174a.87.87,0,0,1,.3.08,5.1,5.1,0,0,1,.82.37,9.75,9.75,0,0,1,2.65,2,10.56,10.56,0,0,1,2.46,4.25,12.21,12.21,0,0,1,.44,2.88c.07,1,.14,2,.21,3.07.28,4.21.51,8,.65,10.78,0,1.3.1,2.39.13,3.27a5.21,5.21,0,0,1,0,1.21,5.68,5.68,0,0,1-.18-1.19c-.08-.88-.18-2-.3-3.26-.23-2.76-.52-6.57-.8-10.78-.07-1.05-.13-2.08-.2-3.07a11.65,11.65,0,0,0-.4-2.78A10.5,10.5,0,0,0,193,176.7,14.44,14.44,0,0,0,189.49,174Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.52,229s2.42,2.72,4.41,3.33h9.42a9.34,9.34,0,0,0,4.59-3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.44,234.34h6.17A6.69,6.69,0,0,1,195.3,241v.7a0,0,0,0,1,0,0H175.75a0,0,0,0,1,0,0V241A6.69,6.69,0,0,1,182.44,234.34Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.42,
    y: 230.63,
    width: 10.05,
    height: 5.26,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.13,
    y: 241.22,
    width: 28.44,
    height: 2.61,
    rx: 1.18,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193,206.35a51.55,51.55,0,0,1-7.26.26,51.34,51.34,0,0,1-7.25-.26,48.7,48.7,0,0,1,7.25-.27A48.89,48.89,0,0,1,193,206.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.28,191.77a82.56,82.56,0,0,1-9.44.27,82.41,82.41,0,0,1-9.44-.27,86.9,86.9,0,0,1,9.44-.26A87.05,87.05,0,0,1,195.28,191.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.59,232.15a24.64,24.64,0,0,1-5,.26,24.64,24.64,0,0,1-5-.26,24.64,24.64,0,0,1,5-.26A24.64,24.64,0,0,1,190.59,232.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190,234.41a23,23,0,0,1-4.84.26,22.92,22.92,0,0,1-4.83-.26,22.92,22.92,0,0,1,4.83-.26A23,23,0,0,1,190,234.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.25,241.36c0,.15-4.84.26-10.8.26s-10.81-.11-10.81-.26,4.84-.26,10.81-.26S197.25,241.22,197.25,241.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.78,236c0,.14-.83.29-1.88.32s-1.89-.06-1.89-.2.83-.29,1.88-.32S186.78,235.81,186.78,236Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.57,207.94c0,.14-.76.28-1.7.32s-1.7-.06-1.7-.21.75-.28,1.69-.31S187.56,207.79,187.57,207.94Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.17,190.94a17,17,0,0,1-5.92.38,9,9,0,0,1,2.95-.45A8.9,8.9,0,0,1,188.17,190.94Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.59,221.32a18.05,18.05,0,0,1-.05-4.24,17.85,17.85,0,0,1,.47-4.21,16.81,16.81,0,0,1,.05,4.24A16.78,16.78,0,0,1,172.59,221.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.48,220.54a31,31,0,0,1-1.24-6.38,30.76,30.76,0,0,1-.38-6.49,59,59,0,0,1,.9,6.42A59.58,59.58,0,0,1,199.48,220.54Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "191.78 227.19 191.06 239.63 190.48 227.19 179.65 226.61 190.46 226.04 191.11 213.78 191.63 226.05 205.52 226.66 191.78 227.19",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "190.1 226.41 187.29 221.9 190.79 225.93 190.1 226.41",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "191.1 226.1 194.87 222.4 191.7 226.71 191.1 226.1",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "191.78 227 194.58 231.51 191.08 227.48 191.78 227",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "190.77 227.31 187.01 231.01 190.17 226.71 190.77 227.31",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.7,117.47a18.73,18.73,0,0,1-2.72-.8c-1.67-.54-4-1.23-6.57-1.88s-5-1.1-6.68-1.41a19.88,19.88,0,0,1-2.78-.56,13.07,13.07,0,0,1,2.84.19,59.85,59.85,0,0,1,6.75,1.28,58.83,58.83,0,0,1,6.56,2A13,13,0,0,1,202.7,117.47Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Box--inject-26"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 258.16,
    y: 401.9,
    width: 113.49,
    height: 81.59,
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.6,401.9c.16,0,0,17.23,0,17.23h-8.4V401.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 314.9,
    y: 401.9,
    width: 56.74,
    height: 81.59,
    transform: "translate(686.55 885.4) rotate(180)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 261.62,
    y: 467.52,
    width: 15.19,
    height: 10.75,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279.62,
    y: 467.52,
    width: 7.6,
    height: 10.75,
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M474.08,483.49c0,.15-100.33.26-224.07.26s-224.09-.11-224.09-.26,100.31-.26,224.09-.26S474.08,483.35,474.08,483.49Z",
    style: {
      fill: "#263238"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNosearch2);
export default __webpack_public_path__ + "static/media/nosearch2.bab25c61c3240fac445393193521a963.svg";
export { ForwardRef as ReactComponent };